<div class="row">
    @for(data of blogData;track $index){
    <div class="col-lg-4 col-md-6 mt-4 pt-2">
        <div class="card blog blog-primary rounded border-0 shadow" style="height: 100%">
            <div class="position-relative">
                <img src="{{data.image}}" class="card-img-top rounded-top" alt="..." height="100%">
                <div class="overlay rounded-top"></div>
            </div>
            <div class="card-body content">
                <h5><a href="javascript:void(0)" class="card-title title text-dark">{{data.title}}</a>
                </h5>

            </div>
        </div>
    </div>
}
</div>
